import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Image } from './image';
export { Image };
import { imageSchema } from '@schemas/business-objects/image';
import { ResourceFormGroup } from './resource-form-group';
import type { TextBox } from './text-box';
import type { User } from './user';

export class ImageFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    fileName: SchemaFormControl;
    mimeType: SchemaFormControl;
    size: SchemaFormControl;
    base64Content: SchemaFormControl;
    fixedPosition: SchemaFormControl;
    sequence: SchemaFormControl;
    positionX: SchemaFormControl;
    positionY: SchemaFormControl;
    isBackground: SchemaFormControl;
    locked: SchemaFormControl;
    resourceId: SchemaFormControl;
    resource: ResourceFormGroup;
  };

  declare value: Partial<Image>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(imageSchema, Image, data, options);
  }

  get object(): Image {
    return new Image(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'resource':
        return new ResourceFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Image[]> {
    return Image.find(filter);
  }

  static async findOne(filter?: any): Promise<Image | null> {
    return Image.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Image> {
    return Image.findById(id, filter);
  }

  static async create(data: Partial<Image>): Promise<Image> {
    return Image.create(data as any);
  }

  static async updateById(id: number, updates: Partial<Image>): Promise<Image> {
    return Image.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Image.deleteById(id);
  }

  async dataForCopy(): Promise<any> {
    const instance = new Image(this.getRawValue());
    return instance.dataForCopy();
  }

  async content(): Promise<any> {
    const instance = new Image(this.getRawValue());
    return instance.content();
  }
}

export class ImageFormArray extends PersistedFormArray {
  readonly entityName = 'Image' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(imageSchema, Image, options);
  }

  protected override createItemGroup() {
    return new ImageFormGroup();
  }

  get array(): Image[] {
    return this.controls.map((group: ImageFormGroup) => group.object);
  }
}

export class ImagePersistedArray extends PersistedArray<Image> {
  readonly entityName = 'Image' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Image, options);
  }
}
